import React from "react";
import { connect } from "react-redux";
import { notification } from "antd";
import { setLoader } from "store/actions";
import { store } from "store";
import { API, Endpoints } from "utils/api";
import { Helmet } from "react-helmet";
import { ContentWrapper, ManualItem } from "components";
import { FileUnknownOutlined } from "@ant-design/icons";
import { Ethic } from "screens/Admin/Ethics/types";
import Strings from "utils/strings";
import "./styles.scss";

type State = {
	ethics?: Ethic[];
};
type Props = {
	language: string;
	dispatch: typeof store.dispatch;
};

class Ethics extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);

		this.state = {
			ethics: []
		};
	}

	componentDidMount(): void {
		this.getData();
	}

	async getData() {
		const { dispatch } = this.props;

		dispatch(setLoader(true));

		try {
			const response = await API.get({
				url: Endpoints.uriManuals(),
				params: { type: "ethics" }
			});

			if (response?.ok) {
				const ethics: Ethic[] = response.data.results.ethics || [];
				this.setState({ ethics });
			} else {
				notification.error({
					message: Strings.serverErrors.title,
					description: response?.data?.message || Strings.serverErrors.wentWrong,
					placement: "bottomRight",
					duration: 5
				});
			}
		} catch (err: unknown) {
			notification.error({
				message: Strings.serverErrors.title,
				description: err as string,
				placement: "bottomRight",
				duration: 5
			});
		}

		dispatch(setLoader(false));
	}

	renderGallery() {
		const { ethics = [] } = this.state;

		return (
			<ContentWrapper>
				<div className="ScreenHeader">
					<div className="ScreenHeaderLeft">
						<FileUnknownOutlined translate={null} />
						<h2>{Strings.settings.ethics}</h2>
					</div>
				</div>
				<div className="PartnerManualGrid">
					{ethics.map((manual, i) => {
						return <ManualItem key={i} readonly isEthic {...manual} />;
					})}
				</div>
				{ethics.length === 0 && (
					<div className="PartnerManualHeader">
						<h3>{Strings.settings.noFilesPartner}</h3>
					</div>
				)}
			</ContentWrapper>
		);
	}

	render() {
		return (
			<React.Fragment>
				<Helmet>
					<title>{Strings.settings.ethics}</title>
					<meta name="description" content={Strings.settings.ethics} />
				</Helmet>
				{this.renderGallery()}
			</React.Fragment>
		);
	}
}

const mapStateToProps = (state: { language: string }) => ({
	language: state.language
});

export default connect(mapStateToProps)(Ethics);
